import { useState } from "react";
import { Button, Form } from "antd";
import { useQuery } from "@apollo/client";
import { UpOutlined, DownOutlined } from "@ant-design/icons";
import { VouchersFilters as VouchersFiltersType } from "@/types";
import { LIST_TIERS } from "../queries";
import { filters } from "./data";

type VouchersFiltersProps = {
	submitFilters: ({
		voucher,
		first,
		page,
	}: {
		first: number;
		page: number;
		voucher: VouchersFiltersType;
	}) => void;
};

const useVouchersFilters = ({ submitFilters }: VouchersFiltersProps) => {
	const [form] = Form.useForm();
	const [isFilterApplied, setIsFilterApplied] = useState<boolean>(false);

	const { data: tiersData, loading: tiersLoading } = useQuery(LIST_TIERS);

	let tiers = tiersData?.getTiers || "";

	tiers = [{ label: "All", value: "all" }].concat(tiers);

	const initialValues = {
		tier: "all",
		status: "all",
		search: "",
	};

	const onApplyFilters = (_: string, { forms }: any) => {
		const allFeilds = {
			...forms.vouchersFilters.getFieldsValue(),
			...forms.searchForm.getFieldsValue(),
		};

		// TODO: revisit this type affecting the any above.
		let values: {
			[index: string]: string | null | { from: string; to: string } | string[];
		} = {};

		values = {
			...allFeilds,
		};

		// strip out the values that the query doesn't need, like "all" for type, we can't do something like !values[key] because it will remove the falsy value of validity
		Object.keys(values).forEach((key) => {
			if (
				values[key] === null ||
				values[key] === "all" ||
				(Array.isArray(values[key]) && (values[key] as [])?.length === 0)
			) {
				delete values[key];
			}
		});

		submitFilters({
			voucher: values,
			first: 10,
			page: 1,
		});
		setIsFilterApplied(true);
	};

	const clearFilters = () => {
		form.resetFields(["tier", "status", "search"]);
	};

	const resetFields = () => {
		clearFilters();
		form.submit();
	};

	const expandIcon = ({ isActive }: { isActive?: boolean }) =>
		isActive ? (
			<Button
				style={{ borderColor: "#4A90E2", color: "#4A90E2" }}
				type="default"
			>
				Hide Filters <UpOutlined />
			</Button>
		) : (
			<Button
				style={{ borderColor: "#4A90E2", color: "#4A90E2" }}
				type="default"
				loading={tiersLoading}
			>
				Show Filters <DownOutlined />
			</Button>
		);

	return {
		expandIcon,
		filters,
		onApplyFilters,
		form,
		initialValues,
		resetFields,
		isFilterApplied,
		tiers,
	};
};

export default useVouchersFilters;
